<div class="login-container">
  <section class="login-header">
    <div class="logo-container">
      <span class="material-symbols-rounded">
        water_drop
      </span>
    </div>

    <h1 class="title">
      AquaGuard
    </h1>

    <h2 class="sub-title">
      {{ 'common.title.monitoring-system' | translateSafe }}
    </h2>
  </section>

  <form class="login-form"
        [formGroup]="loginForm"
        (submit)="doLogin()">
    <app-input-text [formData]="usernameConfig" />

    <app-input-text [formData]="passwordConfig" />

    <app-input-submit [formData]="submitConfig" />
  </form>

  @if (azureLoginLink) {
    <div class="or-split">
      <hr>
      <span>oder</span>
      <hr>
    </div>

    <a class="azure-login"
       [href]="azureLoginLink">
      <svg height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.986 452.986"
           xml:space="preserve">
          <g>
            <path style="fill:#eee;" d="M165.265,53.107L21.689,81.753v132.531l143.575-2.416V53.107 M431.297,245.583l-233.18-3.991
              v164.822l233.18,46.571V245.583 M165.265,241.097l-143.575-2.438v132.509l143.575,28.668V241.097 M431.297,0l-233.18,46.528
              v164.822l233.18-3.969V0"/>
          </g>
        </svg>
      <span>
          Microsoft Azure Entra
        </span>

    </a>
  }

  <p class="copy-right">
    &copy; {{ currentYear }} <a href="https://sensora.lu/" target="_blank" rel="noopener noreferrer">Sensora.lu</a>
  </p>
</div>
